export default "__VITE_ASSET__BFv25ujO__"